<ng-template #buttons>
  <ul class="b-workbench-filter__tabs-menu b-tablist" hide-empty>
    <ng-content select="f-facet[name=buttons],w-li-button,facet-buttons"
      description="insert w-li-button components"></ng-content>
  </ul>
</ng-template>
<ng-template #controls>
  <ng-content select="f-facet[name=controls],[facet-controls]" description="Additional input fields"></ng-content>
</ng-template>
<ng-template #search>
  <w-input-search [placeholder]="placeholder" *ngIf="showSearch" [(ngModel)]="value" (wKeyup)="keyup($event)"
    (wChange)="wChange.emit($event)" [title]="tooltip">
    <ng-content select="f-facet[name=search-links],[facet-search-links]"
      description="links dropdown in search component" facet-info></ng-content>
  </w-input-search>
</ng-template>
<div class="b-workbench-filter{{toggle ? ' toggle-filter' : ''}}">
  <div class="b-workbench-filter__header">
    <ng-container [ngTemplateOutlet]="section" *ngFor="let section of sections"></ng-container>
  </div>
  <ng-content select="f-facet[name=drawers],[facet-drawers]"></ng-content>
</div>